/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Free_Quail_PeekInputs */

const en_soft_free_quail_peek = /** @type {(inputs: Soft_Free_Quail_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const de_soft_free_quail_peek = /** @type {(inputs: Soft_Free_Quail_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Soft_Free_Quail_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_free_quail_peek = /** @type {((inputs?: Soft_Free_Quail_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Free_Quail_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_free_quail_peek(inputs)
	return de_soft_free_quail_peek(inputs)
});